import React from 'react'
import { Navbar } from 'react-bootstrap'
import { Nav } from 'react-bootstrap'

const Header = () => {
  return (
    <Navbar bg="primary" expand="lg" variant="dark">
        <Navbar.Brand href='/'>KojoBarbie's Port Folio</Navbar.Brand>
        <Navbar.Collapse id='basic-navbar-nav'>
            <Nav className='me-auto'>
                <Nav.Link href='/'>Home</Nav.Link>
                <Nav.Link href='/about'>About</Nav.Link>
                <Nav.Link href='/works'>Works</Nav.Link>
            </Nav>
        </Navbar.Collapse>
    </Navbar>
  )
}

export default Header